import React from "react";
import NewPatientForm from "./components/NewPatientForm";
import { GlobalContainer } from "../../common/components/Container";
const AddNewPatient = () => {
  return (
    <GlobalContainer theme="purple">
      <NewPatientForm />
    </GlobalContainer>
  );
};

export default AddNewPatient;
